globalThis.redoStorefront = {
  type: "custom-lightopia",
  storeUrl: location.host,
  env: {
    REDO_API_CLIENT_VERSION: "",
    REDO_API_URL: "https://shopify-cdn.getredo.com",
    REDO_SHOPIFY_SERVER_URL: "https://shopify-server.getredo.com",
    REDO_SHOPIFY_EXTENSION_URL: "auto",
    AMPLITUDE_API_KEY: "4ea5fb67e1313890e096ab17cce5d093",
  },
};
globalThis.process = {
  env: {
    REDO_API_CLIENT_VERSION: "",
    REDO_API_URL: "https://shopify-cdn.getredo.com",
    REDO_SHOPIFY_SERVER_URL: "https://shopify-server.getredo.com",
    REDO_SHOPIFY_EXTENSION_URL: "auto",
    AMPLITUDE_API_KEY: "4ea5fb67e1313890e096ab17cce5d093",
  },
};
